import { isDevelopment } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import * as styles from "./GTMBody.styles";

interface Props {
  googleTagManager?: string;
}

const GTMBody = ({ googleTagManager }: Props) => {
  if (isDevelopment() || !googleTagManager) return;

  return (
    <noscript data-testid="noscript">
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${googleTagManager}`}
        height="0"
        width="0"
        css={styles.GTMBody}
      ></iframe>
    </noscript>
  );
};

export { GTMBody };
